import { render, staticRenderFns } from "./ContactIcon.vue?vue&type=template&id=a890d6cc&"
var script = {}


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\_Lavoro\\ALCYON\\Homestead\\code\\reporting\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a890d6cc')) {
      api.createRecord('a890d6cc', component.options)
    } else {
      api.reload('a890d6cc', component.options)
    }
    module.hot.accept("./ContactIcon.vue?vue&type=template&id=a890d6cc&", function () {
      api.rerender('a890d6cc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/icon/ContactIcon.vue"
export default component.exports